// removed by extract-text-webpack-plugin
module.exports = {"withPointer":"_3kM-e-rM7lRcyFkXMPJ8Nd","modal":"qX1UMul9sl2cHLSHfEXT7","title":"_1Q9qCf4rcdBe44ZMEpLMUD","contentWrapper":"_1VrBPVekPmi94H1qSGPzvA","content":"_33N_1b8wp-A0UNC6kgyAgg","buttons":"LLOHhSl-Xhu8MHOkFj3TD","next":"_2JFR1X2Zu-8txx9PTF2qwt","enabled":"_39-aR9twMAb5PelALnDbts","gray":"_1iBfZj32LyYPIBYbHQqbSJ","cancel":"_2MV-_n4ByKj2bWS_1wCtSs"};


//////////////////
// WEBPACK FOOTER
// ./components/emailSender/confirmationDialog.scss
// module id = 1607
// module chunks = 0